import React from "react";
import { Chip, Typography } from "@mui/material";
import VerifiedOutlinedIcon from '@mui/icons-material/VerifiedOutlined';
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  CardRoot,
  HeaderRow,
  LeftBlock,
  IconTile,
  TitlePrice,
  PriceRow,
  InfoBar,
  RightBlock,
} from "./styles";

export type PlanInfoCardProps = {
  name: string;
  priceMonthly: number;
  currency?: string; // default: R$
  badgeLabel?: string; // ex: Stripe PCI SAQ-A
  infoLead?: string; // ex: Leva menos de 1 minuto.
  infoText?: string; // restante do texto
};

const formatPrice = (value: number) =>
  new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 2 }).format(value);

export const PlanInfoCard: React.FC<PlanInfoCardProps> = ({
  name,
  priceMonthly,
  currency = "R$",
  badgeLabel = "Stripe PCI SAQ-A",
  infoLead = "Leva menos de 1 minuto.",
  infoText = "Hoje você paga a Adesão ao seu agente. Em seguida ativamos sua Assinatura no cartão.",
}) => {
  return (
    <CardRoot elevation={0}>
      <HeaderRow>
        <LeftBlock>
          <IconTile>
            <VerifiedOutlinedIcon fontSize="small" />
          </IconTile>
          <TitlePrice>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1 }}>
              {name}
            </Typography>
            <PriceRow>
              <Typography variant="body2" color="primary" sx={{ fontWeight: 600 }}>
                {currency} {formatPrice(priceMonthly)}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                /mês
              </Typography>
            </PriceRow>
          </TitlePrice>
        </LeftBlock>

        <RightBlock>
          <Chip
            icon={<LockOutlinedIcon sx={{ fontSize: 18 }} />}
            label={badgeLabel}
            variant="outlined"
            sx={{
              bgcolor: "#ffffff",
              borderColor: "#E1E8FF",
              color: "#1a73e8",
              fontWeight: 500,
              "& .MuiChip-label": { px: 1 },
            }}
          />
        </RightBlock>
      </HeaderRow>

      <InfoBar>
        <InfoOutlinedIcon sx={{ color: "#1a73e8", mr: 1 }} fontSize="small" />
        <Typography variant="body2">
          <strong>{infoLead}</strong> {infoText}
        </Typography>
      </InfoBar>
    </CardRoot>
  );
};

export default PlanInfoCard;